export const TABS = {
  overview: "overview",
  aiComponents: "aiComponents",
  aiRisks: "aiRisks"
}

export const TABS_DEMO = {
  aiPolicy: "aiPolicy"
}
